import { render, staticRenderFns } from "./GroupTitleVerificationList.vue?vue&type=template&id=a7536430&"
import script from "./GroupTitleVerificationList.vue?vue&type=script&lang=js&"
export * from "./GroupTitleVerificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports